// ============================================================
// Ask Simply — animated hero chat
// Plays once when the hero scrolls into view. Respects
// prefers-reduced-motion (CSS shows the final state instantly).
// Self-contained vanilla JS, ported from the designer's package.
// ============================================================

(function () {
    function initHeroAnim(root) {
        if (!root || root.dataset.asaInit === '1') { return; }
        root.dataset.asaInit = '1';

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var frame = root.querySelector('[data-hero-anim]');
        if (!frame) { return; }

        var cs = getComputedStyle(frame);
        var t = function (n) { return parseFloat(cs.getPropertyValue(n)) || 0; };
        function add(sel, cls) {
            var el = frame.querySelector(sel);
            if (el) { el.classList.add(cls || 'is-in'); }
        }

        // ---- responsive: scale the 721x669 artboard to wrapper width ----
        var FW = t('--asa-fw') || 721;
        var FH = t('--asa-fh') || 669;
        function fit() {
            var s = root.clientWidth / FW;
            frame.style.transform = 'scale(' + s + ')';
            root.style.height = (FH * s) + 'px';
        }
        if ('ResizeObserver' in window) {
            new ResizeObserver(fit).observe(root);
        } else {
            window.addEventListener('resize', fit);
        }
        fit();

        // ---- type text into the user bubble ----
        function typeUser(done) {
            var el = frame.querySelector('.asa-user-text');
            var txt = el.getAttribute('data-text') || '';
            var speed = t('--asa-type-speed') || 34;
            var i = 0;
            el.textContent = '';
            el.classList.add('is-typing');
            (function step() {
                if (i <= txt.length) {
                    el.textContent = txt.slice(0, i);
                    i++;
                    setTimeout(step, speed);
                } else {
                    el.classList.remove('is-typing');
                    if (done) { done(); }
                }
            })();
        }

        // ---- storyboard ----
        function play() {
            if (reduce) { return; } // CSS already shows the final state
            // start the user bubble empty so it only appears via the typing
            // animation (the static text stays in the markup for reduced-motion / no-JS)
            var userText = frame.querySelector('.asa-user-text');
            if (userText) { userText.textContent = ''; }
            add('.asa-layer--glow');
            setTimeout(function () { add('.asa-layer--avatar'); }, t('--asa-d-avatar') || 200);
            setTimeout(function () { add('.asa-layer--user'); }, t('--asa-d-user') || 650);
            setTimeout(function () { typeUser(afterTyping); }, t('--asa-d-type') || 1050);
        }
        function afterTyping() {
            var pause = t('--asa-gap-after-type') || 350;
            var dots = t('--asa-d-dots') || 1200;
            setTimeout(function () { add('.asa-layer--blob'); add('.asa-layer--reply'); }, pause);
            setTimeout(function () { frame.querySelector('.asa-layer--reply').classList.add('is-done'); }, pause + dots);
            setTimeout(function () { add('.asa-reply-check'); }, pause + dots + 200);
            setTimeout(function () { add('.asa-reply-line--1'); }, pause + dots + 380);
            setTimeout(function () { add('.asa-reply-line--2'); }, pause + dots + 540);
        }

        // ---- trigger once when in view ----
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (e.isIntersecting) { play(); io.disconnect(); }
                });
            }, { threshold: 0.45 });
            io.observe(frame);
        } else {
            play();
        }
    }

    function boot() {
        var roots = document.querySelectorAll('.ai-assistant__hero-anim');
        for (var i = 0; i < roots.length; i++) { initHeroAnim(roots[i]); }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
